import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import { TooltipContent } from '../../../common/styled';
import { useIntl, useIsSearching, useStoreActions } from '../../../state';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { TooltipTag } from '../../tooltip-tag';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { BaseSearch } from '../base-search';
import { messages } from './messages';
export var Search = function Search() {
  var _useIntl = useIntl(),
    _useIntl2 = _slicedToArray(_useIntl, 1),
    intl = _useIntl2[0];
  var _useStoreActions = useStoreActions(),
    _useStoreActions2 = _slicedToArray(_useStoreActions, 2),
    onSearch = _useStoreActions2[1].onSearch;
  var label = intl.formatMessage(messages.searchLabel);
  var _useIsSearching = useIsSearching(),
    _useIsSearching2 = _slicedToArray(_useIsSearching, 1),
    isSearching = _useIsSearching2[0];
  return /*#__PURE__*/React.createElement(Tooltip, {
    position: 'bottom',
    content: /*#__PURE__*/React.createElement(TooltipContent, null, label)
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    ,
    tag: TooltipTag
  }, /*#__PURE__*/React.createElement(BaseSearch, {
    label: label,
    onSearch: onSearch,
    isSearching: isSearching
  }));
};